import { filter, isArray, size } from 'lodash';

import { initDictionaryList } from '../../../AdminTools/components/Dictionary/actions';
import { setMessageExportUnavailable } from '../../../../common/components/Alert/actions';
import APIClient from '../../../../common/services/APIClient';
import PlazaController from '../../../../common/controllers/plaza/PlazaController';
import { fileDownload } from '../../../../common/services/fileUtils';

export const loadPlazasList = (name) => (dispatch) => {
  PlazaController.getAll().then((list) => {
    const shownPlazas = filter(list, (item) => !item.hidden);

    dispatch(initDictionaryList(name, {
      dictionary: shownPlazas,
      totalSize: size(shownPlazas),
      selected: [],
    }));
  });
};

export const exportDictionary = (dictionaryType, uuids = [], sorting) => (dispatch) => {
  let tableSorting;

  if (isArray(sorting)) {
    tableSorting = sorting[0] || { id: 'value', desc: false };
  } else {
    tableSorting = sorting;
  }

  const params = {
    sortBy: tableSorting.id,
    sortOrder: tableSorting.desc ? 'DESC' : 'ASC',
  };

  const payload = {
    filterBy: { uuids },
  };

  return APIClient.post('/plazas/export', payload, { params })
    .then(({ data, headers }) => {
      fileDownload(data, `exported-${dictionaryType.toLowerCase()}.csv`, headers['content-type']);
    })
    .catch((err) => {
      if (err.response && err.response.status === 500) {
        dispatch(setMessageExportUnavailable());
      }
      console.error(err);
    });
};
